/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader,
  Button, Spinner, Input, InputGroup,
  Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

// import BaseGrid from '../../components/Common/BaseGrid';
import { Can } from '../../utilities/Can';
import { get, post } from '../../helpers/api_helper';
import ReturnReasonPerformance from '../../components/HappyReturns/ReturnReasonPerformance';
// import * as url from '../../helpers/url_helper';

function HappyReturns(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [loading, setLoading] = useState(false);
  const [output, setOutput] = useState(null);
  const [activeTab, setActiveTab] = useState('performance');

  const ecRef = useRef(null);
  const webhookRef = useRef(null);
  const webhookBtn = useRef(null);

  const { t } = props;

  const getReturnItemsByExpressCode = async (ec) => {
    try {
      const res = await get(`/api/happyreturns/itemsByExpressCode/${ec}`);
      setOutput(res);
    } catch (e) {
      toastr.error(t('Error loading remote data'));
    } finally {
      setLoading(false);
    }
  };

  const getReturnItemsByOrderReference = async (oref) => {
    try {
      const res = await get(`/api/happyreturns/itemsByOrderRef/${oref}`);
      setOutput(res);
    } catch (e) {
      toastr.error(t('Error loading remote data'));
    } finally {
      setLoading(false);
    }
  };

  const registerWebhook = async () => {
    try {
      const webhookStr = webhookRef.current.value;
      webhookBtn.current.disabled = true;
      await post(`/api/happyreturns/webhook/register?hook=${encodeURIComponent(webhookStr)}`);

      toastr.success('Webhook Subscribed');
    } catch (e) {
      toastr.error(e.response.data, t('Error registering webhook'));
    } finally {
      webhookBtn.current.disabled = false;
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl="12">
            <Nav tabs className="nav-tabs-custom mb-3">
              <NavItem>
                <NavLink
                  className={activeTab === 'performance' ? 'active' : ''}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setActiveTab('performance')}
                >
                  {t('Performance')}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === 'utilities' ? 'active' : ''}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setActiveTab('utilities')}
                >
                  {t('Utilities')}
                </NavLink>
              </NavItem>
            </Nav>

            <TabContent activeTab={activeTab}>
              <TabPane tabId="performance">
                <Can i="see" this="happy_returns">
                  <Row>
                    <Col xxl="7">
                      <ReturnReasonPerformance t={t} />
                    </Col>
                  </Row>
                </Can>
                <Can not i="see" this="slack"><p>{props.t('Unauthorized')}</p></Can>
              </TabPane>

              <TabPane tabId="utilities">
                <Row>
                  <Col xl="6">
                    <Card>
                      <CardHeader className="bg-transparent border-bottom">
                        {t('RMA Items Browser')}
                      </CardHeader>
                      <CardBody>
                        <Can i="see" this="happy_returns">
                          <InputGroup>
                            <Input bsSize placeholder="Express Code/Order Reference" innerRef={ecRef} />
                            <Button
                              color="info"
                              className="btn-soft-info"
                              onClick={async () => {
                                setLoading(true);

                                await getReturnItemsByExpressCode(ecRef.current.value);

                                setLoading(false);
                              }}
                            >
                              {loading && (
                                <>
                                  <Spinner size="sm" />
                                  {' '}
                                  {t('Loading...')}
                                </>
                              )}
                              {!loading && t('Express Code')}
                            </Button>
                            <Button
                              color="primary"
                              className="btn-soft-primary"
                              onClick={async () => {
                                setLoading(true);

                                await getReturnItemsByOrderReference(ecRef.current.value);

                                setLoading(false);
                              }}
                            >
                              {loading && (
                                <>
                                  <Spinner size="sm" />
                                  {' '}
                                  {t('Loading...')}
                                </>
                              )}
                              {!loading && t('Order Reference')}
                            </Button>
                          </InputGroup>

                          {output !== null && (
                            <pre className="mt-4">{JSON.stringify(output, null, 2)}</pre>
                          )}
                        </Can>

                        <Can not i="see" this="slack"><p>{props.t('Unauthorized')}</p></Can>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xl="6">
                    <Card>
                      <CardHeader className="bg-transparent border-bottom">
                        {t('Register Webhooks')}
                      </CardHeader>
                      <CardBody>
                        <div className="col-sm-6">
                          <InputGroup>
                            <input ref={webhookRef} type="text" className="form-control" />
                            <Button color="primary" size="sm" onClick={registerWebhook} innerRef={webhookBtn}>
                              {t('Register Webhook')}
                            </Button>
                          </InputGroup>
                        </div>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </div>
    </div>
  );
}

HappyReturns.defaultProps = {
  t: (x) => (x),
};

HappyReturns.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(HappyReturns));
